import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-lists-28',
  templateUrl: './28.component.html',
})
export class VbList28Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
